import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useUserLocale } from 'common/hooks/useUserLocale';
import { formatDateRange } from 'common/utils/dates/dateUtils';

import { OverridePeriod } from '../api-types';

type Props = {
  override: OverridePeriod;
};

const Section = styled(Stack)`
  padding: 24px;
  margin: 12px;
  border-top: 1px solid ${color.border};

  &:first-of-type {
    border-top: none;
  }
`;

const TextSubdued = styled(T.footnote)`
  color: ${color.textSubdued};
`;

export const OverrideDetailSection = ({ override }: Props) => {
  const format = useFormatMessage();
  const userLocale = useUserLocale();

  return (
    <Section gap="narrowMedium">
      <T.footnote>{override.overrideName}</T.footnote>
      <Stack gap="narrowSmall" direction="row">
        <TextSubdued>{format('forecasting.dates')}</TextSubdued>
        <T.footnote>
          {formatDateRange(userLocale, {
            start: new Date(override.startDate),
            end: new Date(override.endDate),
          })}
        </T.footnote>
      </Stack>
    </Section>
  );
};
